<template>
  <div class="login">
    <!-- The head, on the server. The login screen carries noindex from the
         resolver, so a crawler reads it out of the first response instead of
         depending on this component to inject it. See Layouts/Admin.vue for what
         the hand-injected version of this did to the rest of the session. -->
    <page-meta />
    <form class="card" @submit.prevent="submit">
      <div class="card__head">
        <h1>Sign in</h1>
        <p>Admin panel</p>
      </div>

      <label class="field">
        <span>Email Address</span>
        <input
          v-model="form.email"
          type="email"
          name="email"
          autocomplete="username"
          placeholder="Enter your email address"
          required
        />
      </label>

      <label class="field">
        <span>Password</span>
        <input
          v-model="form.password"
          type="password"
          name="password"
          autocomplete="current-password"
          placeholder="Enter your password"
          required
        />
      </label>

      <p v-if="error" class="error">{{ error }}</p>

      <button type="submit" class="submit" :disabled="submitting">
        {{ submitting ? 'Signing in…' : 'Sign in' }}
      </button>
    </form>
  </div>
</template>

<script>
import PageMeta from '@/Components/PageMeta.vue';

export default {
  components: {
    PageMeta
  },

  data() {
    return {
      form: {
        email: '',
        password: ''
      },
      submitting: false
    };
  },

  computed: {
    error() {
      const errors = this.$page.props.errors || {};
      return errors.email || errors.password || null;
    }
  },

  methods: {
    submit() {
      if (this.submitting) return;
      this.submitting = true;
      this.$inertia.post(this.route('login'), this.form, {
        onFinish: () => {
          this.submitting = false;
        }
      });
    }
  }
};
</script>
